import React from "react";

export const CorrectIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
    >
      <path
        d="M6.79289 15.1952L0.292881 8.66671C-0.097627 8.27449 -0.097627 7.63855 0.292881 7.24629L1.70706 5.82587C2.09757 5.43361 2.73077 5.43361 3.12128 5.82587L7.5 10.2237L16.8787 0.803931C17.2692 0.41171 17.9024 0.41171 18.2929 0.803931L19.7071 2.22435C20.0976 2.61658 20.0976 3.25252 19.7071 3.64478L8.20711 15.1953C7.81656 15.5875 7.1834 15.5875 6.79289 15.1952Z"
        fill="#3272BE"
      />
    </svg>
  );
};
